
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 138324"}},[_c('g',{attrs:{"data-name":"Group 134914"}},[_c('g',{attrs:{"data-name":"Rectangle 110904","fill":"rgba(38,166,154,0)","stroke":"#26a69a","stroke-width":"2"}},[_c('rect',{attrs:{"width":"32","height":"32","rx":"16","stroke":"none"}}),_c('rect',{attrs:{"x":"1","y":"1","width":"30","height":"30","rx":"15","fill":"none"}})]),_c('path',{attrs:{"d":"M13.869 20.781a1.029 1.029 0 01-.726-.3l-3.874-3.867a1.026 1.026 0 011.451-1.448l3.149 3.142 7.048-7.019a1.037 1.037 0 011.452 0 1.028 1.028 0 010 1.448l-7.77 7.743a1.029 1.029 0 01-.73.301z","fill":"#26a69a"}})])])])
          )
        }
      }
    